<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>کد سری پردازش</label>
                        <input type="tel" class="form-control ltr-input" v-mask="'################'" v-model="trackingCode">
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label><label style="color: red; height: 2px;" >*</label>
                            از تاریخ</label>
                        <Datepicker auto-submit id="from-date" locale="fa" input-format="YYYY-MM-DD HH:II" v-model="fromDate" type="datetime" :locale-config="{
                            fa: {
                                displayFormat: 'jYYYY/jMM/jDD',
                                lang: {label: 'شمسی'}
                            }
                        }" />
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label><label style="color: red; height: 2px;" >*</label>
                            تا تاریخ</label>
                        <Datepicker auto-submit id="to-date" locale="fa" input-format="YYYY-MM-DD" v-model="toDate" type="datetime" :locale-config="{
                            fa: {
                                displayFormat: 'jYYYY/jMM/jDD',
                                lang: {label: 'شمسی'}
                            }
                        }" />
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>نوع عملیات</label>
                        <Vselect v-model="actionType" :reduce="item => item.value" label="title" :options="actionTypes">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>نتیجه عملیات</label>
                        <Vselect v-model="actionResult" :reduce="item => item.value" label="title" :options="actionResults">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
            </div>
            <button class="btn btn-primary px-4" :disabled="!fromDate || !toDate" @click="getData()">
                <i class="si si-magnifier"></i>
                جستجو
            </button>
            <button class="btn btn-secondary px-4 mr-2" :disabled="!fromDate || !toDate" @click="getExcelFile()">دریافت خروجی اکسل</button>
            <hr class="mt-4">
            <div class="table-responsive" v-if="rows.length && isSearched">
                <table class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>کد سری پردازش</th>
                            <th>نوع عملیات</th>
                            <th>نتیجه عملیات</th>
                            <th>جزئیات</th>
                            <th>تاریخ</th>
                            <th>ساعت</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row,index) in rows" :key="index">
                            <td>{{ row.trackingCode }}</td>
                            <td>{{ row.actionTypeTitle }}</td>
                            <td>{{ row.actionResultTitle }}</td>
                            <td>{{ row.detail }}</td>
                            <td>{{ row.persianActionDate }}</td>
                            <td>{{ row.actionTime ? row.actionTime.split('.')[0] : '-' }}</td>
                        </tr>
                    </tbody>
                </table>
                <Pagination v-if="count > 10" :pages="pages" :currentPage="currentPage" :prevPageMethod="prevPage" :nextPageMethod="nextPage" :changePageMethod="changePage" />
                <span>تعداد کل ردیف ها : {{ count }} ردیف</span>
            </div>
            <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
                <p class="mb-0">نتیجه ای یافت نشد</p>
            </div>
            <div class="alert alert-warning mt-4 mb-0" v-if="!isSearched">
                <p class="mb-0">جهت دریافت گزارش پس از انتخاب فیلتر های مورد نظر بر روی جستجو کلیک کنید</p>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from '../Partials/Pagination';
export default {
    name: 'EmailReport',
    data(){
        return {
            isSearched: false,
            showLoading: true,
            trackingCode: null,
            fromDate: null,
            toDate: null,
            actionType: null,
            actionResult: null,
            rows: [],
            actionTypes: [],
            actionResults: [],
            pages: [],
            perPage: 20,
            count: 0,
            currentPage: 1
        }
    },
    components: {Pagination},
    methods: {
        getBaseData(){
            this.$api.post('Lookup/GetLookupList',{lookupName: 'ActionType'}).then(({data}) => {
                if(data.status)
                    this.actionTypes = data.result.items;
            });
            this.$api.post('Lookup/GetLookupList',{lookupName: 'ActionResult'}).then(({data}) => {
                if(data.status)
                    this.actionResults = data.result.items;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        changePage(e = null,page = null){
            if(e)
                e.preventDefault();
            if(page)
                this.currentPage = page;
            this.getData();
        },
        nextPage(e){
            e.preventDefault();
            this.currentPage = this.currentPage + 1;
            this.changePage();
        },
        prevPage(e){
            e.preventDefault();
            this.currentPage = this.currentPage - 1;
            this.changePage();
        },
        getData(){
            this.showLoading = true;
            const postedData = {
                pageNumber: this.currentPage,
                perPage: this.perPage
            };
            if(this.fromDate)
                postedData.fromDate = this.fromDate;
            if(this.toDate)
                postedData.toDate = this.toDate;
            if(this.actionType != null)
                postedData.actionType = parseInt(this.actionType);
            if(this.actionResult != null)
                postedData.actionResult = parseInt(this.actionResult);
            if(this.trackingCode)
                postedData.trackingCode = this.trackingCode;
            this.$api.post('Orders/PostService/SearchPostServiceLog',postedData).then(({data}) => {
                if(data.status){
                    this.rows = data.result.logs;
                    this.count = data.result.totalCount;
                    let calcPages = Math.ceil((this.count ? this.count : this.perPage) / this.perPage);
                    calcPages = calcPages > 1 ? calcPages : 1
                    let pagesArray = [];
                    for(let i = 1;i <= calcPages;i++)
                        pagesArray.push(i);
                    this.pages = pagesArray;
                }
                else
                    this.rows = [];
            }).finally(() => {
                this.showLoading = false;
                this.isSearched = true;
            });
        },
        getExcelFile(){
            this.showLoading = true;
            const postedData = {
                pageNumber: this.currentPage,
                perPage: this.perPage,
                exportToExcel: true
            };
            if(this.fromDate)
                postedData.fromDate = this.fromDate;
            if(this.toDate)
                postedData.toDate = this.toDate;
            if(this.actionType != null)
                postedData.actionType = parseInt(this.actionType);
            if(this.actionResult != null)
                postedData.actionResult = parseInt(this.actionResult);
            if(this.trackingCode)
                postedData.trackingCode = this.trackingCode;
            this.$api.post('Orders/PostService/SearchPostServiceLog',postedData).then(({data}) => {
                if(data.status){
                    let a = window.document.createElement('a');
                    a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result.filename);
                    let fileName = data.result.filename;
                    a.setAttribute('download',fileName);
                    window.document.body.appendChild(a);
                    a.click();
                    window.document.body.removeChild(a);
                }
            }).finally(() => {
                this.showLoading = false;
                this.isSearched = true;
            });
        }
    },
    created(){
        this.getBaseData()
    }
}
</script>